import { useState } from "react";
import { Link, CircularProgress } from "@mui/material";
import DownloadIcon from "@mui/icons-material/Download";
import { downloadDocument } from "../download";

/**
 * Read-only link that downloads a stored document under its original filename
 * — see download.js for why it downloads rather than opening a tab. `urlBase`
 * is for documents served by their own router rather than /documents.
 */
export default function DocumentLink({ doc, urlBase }) {
  const [busy, setBusy] = useState(false);
  if (!doc) return null;

  const download = async () => {
    setBusy(true);
    try {
      await downloadDocument(doc, urlBase);
    } catch {
      // the axios interceptor has already surfaced a toast
    } finally {
      setBusy(false);
    }
  };

  return (
    <Link component="button" type="button" onClick={download} disabled={busy}
          sx={{ display: "inline-flex", alignItems: "center", gap: 0.5 }}>
      {doc.original_filename || "Download"}
      {busy ? <CircularProgress size={12} /> : <DownloadIcon sx={{ fontSize: 14 }} />}
    </Link>
  );
}
